let SMCaptcha

if (!SMCaptcha) {
  setTimeout(() => {
    window.initSMCaptcha({
      organization: 'xNxMh079HgFDeRkJE1qN', //数美后台查看
      // 连接新加坡机房特殊配置项，仅供验证码数据上报新加坡机房客户使用
      // domains: ["captcha-xjp.fengkongcloud.com"],
      // 连接美国机房特殊配置项，仅供验证码数据上报美国机房客户使用
      // domains: ["captcha-fjny.fengkongcloud.com"],
      lang: 'en',
      product: 'popup',
      width: 300
    }, function(instance) {
      initSM(instance)
    })
  }, 1000)
}

const initSM = instance => {
  SMCaptcha = instance

  // 资源加载异常,建议开发时进行监听,便于查询错误
  SMCaptcha.onError((errType, errMsg) => {
    console.log(errType, errMsg)
  });
  SMCaptcha.onReady(function (rootEl, params) {
    window.__SMReady = true;
    // params中包含type字段，'init'-启动后 | 'refresh'-手动刷新图片后 | 'afterFail'-验证失败后
    console.log('onReady', params);
  });
}

export const VerifySM = (cb) => {
  SMCaptcha.reset()
  SMCaptcha.resetSuccessCallback();
  SMCaptcha.onSuccess(cb);
  SMCaptcha.verify();
}
